export default {
  get name(): string {
    return 'EASClient';
  },
};
